import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Footer from '@/components/Footer'
import Population_Identification_Processes from '@/components/Population_Identification_Processes'
import Expanding_Internal_Awareness from '@/components/Expanding_Internal_Awareness'
import Collaborative_Care_Resources from '@/components/Collaborative_Care_Resources'
import Process_Evaluation from '@/components/Process_Evaluation'
import Resource_Library from '@/components/Resource_Library'
import Site_Guide from '@/components/Site_Guide'
import Site_Map from '@/components/Site_Map'
import Legal_Notice from '@/components/Legal_Notice'
import Privacy_Policy from '@/components/Privacy_Policy'
import Contact_Us from '@/components/Contact_Us'
import Cookie_Policy from '@/components/Cookie_Policy'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/',
      name: 'Footer',
      component: Footer,
    },
    {
      path: '/Population_Identification_Processes',
      name: 'PopulationIdentificationProcesses',
      component: Population_Identification_Processes,
    },
    {
      path: '/Expanding_Internal_Awareness',
      name: 'ExpandingInternalAwareness',
      component: Expanding_Internal_Awareness,
    },
    {
      path: '/Collaborative_Care_Resources',
      name: 'CollaborativeCareResources',
      component: Collaborative_Care_Resources,
    },
    {
      path: '/Process_Evaluation',
      name: 'ProcessEvaluation',
      component: Process_Evaluation,
    },
    {
      path: '/Resource_Library',
      name: 'ResourceLibrary',
      component: Resource_Library,
    },
    {
      path: '/Site_Guide',
      name: 'SiteGuide',
      component: Site_Guide,
    },
    {
      path: '/Site_Map',
      name: 'SiteMap',
      component: Site_Map,
    },
    {
      path: '/Contact_Us',
      name: 'ContactUs',
      component: Contact_Us,
    },
    {
      path: '/cookie-policy',
      name: 'CookiePolicy',
      component: Cookie_Policy,
    }

    
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js